import { parseUtcDate } from './utcDate';

/**
 * Drive start timestamp from API (`start_datetime`).
 * @param {object|null|undefined} drive
 * @returns {string|number|Date|null}
 */
export const readStartDateFromDrive = (drive) => drive?.start_datetime ?? null;

/**
 * @param {object|null|undefined} drive
 * @returns {Date|null} local Date instant parsed from UTC storage
 */
export const readStartDateAsDate = (drive) => parseUtcDate(readStartDateFromDrive(drive));

const readDriveIdNumber = (drive) => {
    const id = drive?.drive_id ?? drive?.fk_drive_id;
    const parsed = Number(id);
    return Number.isFinite(parsed) ? parsed : 0;
};

/** Newest start first; ties broken by higher drive id. */
export const compareDrivesByStartDateDesc = (a, b) => {
    const aTime = readStartDateAsDate(a)?.getTime();
    const bTime = readStartDateAsDate(b)?.getTime();

    if (aTime != null && bTime != null && aTime !== bTime) {
        return bTime - aTime;
    }
    if (aTime != null && bTime == null) return -1;
    if (aTime == null && bTime != null) return 1;

    return readDriveIdNumber(b) - readDriveIdNumber(a);
};

/** @param {Array} drives @returns {Array} */
export const sortDrivesByStartDateDesc = (drives) => {
    if (!Array.isArray(drives)) return [];
    return [...drives].sort(compareDrivesByStartDateDesc);
};
